import {MessageInstance} from "antd/lib/message/interface";

export const MessageApi: () => MessageInstance = () => window.messageApi;

// @ts-ignore
window.m = MessageApi;

export default MessageApi;
